"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGoogleCookieUserId = exports.decodeCookie = exports.deleteCookie = exports.setCookie = exports.getCookie = void 0;
const secondsPerDay = 60 * 60 * 24;
const defaultExpiration = 31;
// Get Cookie From Server or Browser
const getCookie = (params) => {
    const { req, name } = params;
    if (req && req.cookies) {
        return req.cookies[name];
    }
    else if (typeof window !== 'undefined') {
        const cookies = document.cookie.split('; ');
        const found = cookies.find((item) => item.startsWith(`${name}=`));
        if (!found)
            return '';
        return found.substring(name.length + 1);
    }
    return '';
};
exports.getCookie = getCookie;
// Create/Renew Cookies
const setCookie = (params) => {
    const { req, res, name, value, expiration } = params;
    const maxAge = (expiration || defaultExpiration) * secondsPerDay * 1000;
    const cookieValue = value || '';
    if (req && res) {
        if (res.headersSent) {
            return null;
        }
        res.cookie(name, cookieValue, {
            domain: `.saatchiart.com`,
            maxAge,
            sameSite: 'lax',
            secure: true,
        });
    }
    else if (typeof window !== 'undefined') {
        const maxAgeSeconds = Math.floor(maxAge / 1000);
        const cookie = `${name}=${cookieValue};domain=.saatchiart.com;max-age=${maxAgeSeconds};path=/;`;
        document.cookie = cookie;
    }
    return cookieValue;
};
exports.setCookie = setCookie;
// Create/Renew Cookies
const deleteCookie = (params) => {
    const { req, res, name } = params;
    if (req && res) {
        res.cookie(name, '', {
            expires: 0,
        });
    }
    else if (typeof window !== 'undefined') {
        const cookie = `${name}=;domain=.saatchiart.com;expires=0;path=/;`;
        document.cookie = cookie;
    }
};
exports.deleteCookie = deleteCookie;
// Decode Cookie - Only write use cases we need to handle
// unescape() is being deprecated and decodeURI/decodeURIComponent is recommended option
// it doesn't escape/parse all characters so you can add special cases
// 'search+query%20%28correct%29' => 'search query (correct)'
const decodeCookie = (value) => decodeURIComponent(value.replace(/\+/g, ' '));
exports.decodeCookie = decodeCookie;
// Google Cookie => '_ga'
// https://stackoverflow.com/questions/16102436/what-are-the-values-in-ga-cookie
const getGoogleCookieUserId = () => {
    const googleUserCookie = (0, exports.getCookie)({
        name: '_ga',
    });
    const [version, domain, userId, timestamp] = (googleUserCookie || '').split('.');
    return `${userId || 0}.${timestamp || 0}`;
};
exports.getGoogleCookieUserId = getGoogleCookieUserId;
